import { makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles(theme => ({
  mainPaper: {
    flex: 1,
    padding: theme.spacing(2),
    overflowY: 'scroll',
    ...theme.scrollbarStyles
  },
  searchContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(2),
    marginBottom: theme.spacing(2),
    flexWrap: 'wrap'
  },
  iconButtonEdit: {
    padding: '6px',
    borderRadius: 8,
    color:
      theme.palette.type === 'dark'
        ? theme.palette.dark_50.main
        : theme.palette.gray_300.main,
    '&:hover': {
      backgroundColor: theme.palette.blue_300.main,
      color: theme.palette.white_100.main
    }
  },
  iconButtonDelete: {
    padding: '6px',
    borderRadius: 8,
    color: theme.palette.red_100.main,
    '&:hover': {
      backgroundColor: theme.palette.red_100.main,
      color: theme.palette.white_100.main
    }
  },
  searchField: {
    flex: 1,
    minWidth: 200
  },
  filterField: {
    minWidth: 180
  },
  dateField: {
    minWidth: 150
  },
  containerActionsButton: {
    display: 'flex',
    alignItems: 'center',
    gap: 4
  },
  statusIcon: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center'
  },
  pendente: {
    color: '#ff9800',
    fontSize: 32
  },
  em_andamento: {
    color: '#ffc107',
    fontSize: 32
  },
  concluido: {
    color: '#4caf50',
    fontSize: 32
  },
  vencido: {
    color: '#f44336',
    fontSize: 32
  },
  suspenso: {
    color: '#9e9e9e',
    fontSize: 32
  },
  actionButtons: {
    display: 'flex',
    gap: theme.spacing(1)
  },
  pauseButton: {
    padding: '6px',
    borderRadius: 8,
    color:
      theme.palette.type === 'dark'
        ? theme.palette.dark_50.main
        : theme.palette.gray_400.main,
    color: theme.palette.white_100.main,
    backgroundColor: theme.palette.blue_300.main,
    '&:hover': {
      color: theme.palette.white_100.main,
      backgroundColor: theme.palette.blue_300.main
    }
  },
  resumeButton: {
    color:
      theme.palette.type === 'dark'
        ? theme.palette.dark_50.main
        : theme.palette.gray_400.main,
    backgroundColor: theme.palette.green_200.main,
    color: theme.palette.white_100.main,
    padding: '6px',
    borderRadius: 8,
    '&:hover': {
      backgroundColor: theme.palette.green_200.main,
      color: theme.palette.white_100.main
    }
  },
  tutorialIcon: {
    marginLeft: theme.spacing(1),
    cursor: 'pointer',
    color: theme.palette.blue_300.main
  },

  content: {
    backgroundColor:
      theme.palette.type === 'dark'
        ? theme.palette.dark_400.main
        : theme.palette.white_100.main,
    padding: '12px',
    display: 'flex',
    alignItems: 'end',
    gap: '8px',
    borderBottom:
      '1px solid' +
      (theme.palette.type === 'dark'
        ? theme.palette.dark_stroke.main
        : theme.palette.gray_stroke.main)
  },
  buttonNewReminders: {
    backgroundColor: theme.palette.green_200.main,
    color: theme.palette.white_100.main,
    borderRadius: 8,
    boxShadow: 'none',
    '&:hover': {
      backgroundColor: theme.palette.blue_300.main,
      boxShadow: 'none'
    }
  }
}))
